module.exports = __webpack_public_path__ + "static/media/as4tj148.e8acc226.png";